var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "z-image",
      class: { "z-image--background": _vm.background },
      style: _vm.backgroundStyles,
    },
    [
      !_vm.background
        ? _c("img", {
            staticClass: "z-image__img",
            style: _vm.imageStyles,
            attrs: { src: _vm.src },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.overlay
        ? _c("div", {
            staticClass: "z-image__overlay",
            style: { background: _vm.overlay },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }